import React, { createContext, useContext, useState } from 'react';

// Create the context
const PopupContext = createContext();

// Popup Provider Component
export const PopupProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Open popup
    const openPopup = () => {
        setIsOpen(true);
    };

    // Close popup
    const closePopup = () => {
        setIsOpen(false);
    };

    const contextValue = {
        isOpen,
        openPopup,
        closePopup
    };

    return (
        <PopupContext.Provider value={contextValue}>
            {children}
        </PopupContext.Provider>
    );
};

// Custom hook to use popup context
export const usePopup = () => {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error('usePopup must be used within a PopupProvider');
    }
    return context;
};

export default PopupContext;